import { getApiUrl } from '../../../config/api';
import { post } from '../../../utils/request-manager';

export default class AddMotivoRechazoViewController {
  constructor() {
    this.motivoRechazo = {
      Descripcion: ''
    };
    this.saving = false;
    this.error = null;
  }

  // Inicialización del controlador
  initialize() {
    this.resetForm();
  }

  // Resetear formulario
  resetForm() {
    this.motivoRechazo = {
      Descripcion: ''
    };
    this.saving = false;
    this.error = null;
  }

  // Actualizar campo
  updateField(field, value) {
    this.motivoRechazo[field] = value;
  }

  // Validar formulario
  validateForm() {
    const errors = [];

    if (!this.motivoRechazo.Descripcion || this.motivoRechazo.Descripcion.trim() === '') {
      errors.push('La descripción es requerida.');
    }

    if (this.motivoRechazo.Descripcion && this.motivoRechazo.Descripcion.length > 500) {
      errors.push('La descripción no puede exceder 500 caracteres.');
    }

    return {
      isValid: errors.length === 0,
      errors
    };
  }

  // Guardar motivo de rechazo
  async saveMotivoRechazo() {
    // Validar formulario
    const validation = this.validateForm();
    if (!validation.isValid) {
      return {
        success: false,
        message: validation.errors.join(' ')
      };
    }

    this.saving = true;
    this.error = null;

    try {
      const formData = {
        MotivoRechazo: this.motivoRechazo
      };

      const response = await post(getApiUrl('/api/MotivoRechazo/guardar'), formData, {}, false);
      
      if (response.data.Number > 0) {
        this.resetForm();
        return {
          success: true,
          message: 'Motivo de rechazo guardado correctamente.',
          response
        };
      } else {
        return {
          success: false,
          message: 'No se pudo guardar el motivo de rechazo.',
          response
        };
      }
    } catch (error) {
      console.error('Error al guardar motivo de rechazo:', error);
      return {
        success: false,
        message: 'No se pudo guardar el motivo de rechazo. Por favor, verifique los datos e intente nuevamente.',
        error
      };
    } finally {
      this.saving = false;
    }
  }
}